import { Link } from "react-router-dom";
import { setConsent } from "@/lib/consent";

export function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-border/70 pt-6 pb-4 flex flex-col sm:flex-row gap-3 justify-between text-xs text-muted-foreground" data-testid="site-footer">
      <div className="space-y-1">
        <p data-testid="footer-copyright">Copyright © {new Date().getFullYear()} <a href="https://pillarwealth.io" className="underline hover:text-foreground" data-testid="footer-site-link">PillarWealth.io</a> by <a href="https://atkinsmedia.io" target="_blank" rel="noopener" className="underline hover:text-foreground" data-testid="footer-atkins-link">Atkins Media, LLC</a>. All rights reserved.</p>
        <p>Educational estimates only, not financial, tax or legal advice.</p>
      </div>
      <nav className="flex flex-wrap items-center gap-4">
        <Link to="/privacy" className="hover:text-foreground" data-testid="footer-privacy-link">Privacy</Link>
        <Link to="/terms" className="hover:text-foreground" data-testid="footer-terms-link">Terms</Link>
        <Link to="/cookies" className="hover:text-foreground" data-testid="footer-cookies-link">Cookies</Link>
        <button type="button" onClick={() => setConsent(null)} className="hover:text-foreground" data-testid="footer-cookie-settings-button">Cookie settings</button>
        <Link to="/support" className="hover:text-foreground" data-testid="footer-support-link">Support</Link>
        <Link to="/contact" className="hover:text-foreground" data-testid="footer-contact-link">Contact</Link>
        <Link to="/editorial-policy" className="hover:text-foreground" data-testid="footer-editorial-link">Editorial policy</Link>
        <Link to="/about" className="hover:text-foreground" data-testid="footer-about-link">About</Link>
      </nav>
    </footer>
  );
}

export function LegalLayout({ title, updated, children }) {
  return (
    <article className="max-w-3xl fade-up">
      <h1 className="text-4xl sm:text-5xl font-semibold text-grad-head" data-testid="page-title">{title}</h1>
      {updated && <p className="text-sm text-muted-foreground mt-3">Last updated {updated}</p>}
      <div className="glass p-6 sm:p-10 mt-8 article-body text-slate-900 dark:text-slate-100">{children}</div>
    </article>
  );
}
